import { HttpTransportType, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import reduxSignalRMiddleware, { withCallbacks } from "_shared/_stores/realtime/redux-signalr-middleware";
import { getSignalRReconnectDelaysMs } from "_shared/_stores/realtime/signalr-reconnect-policy";
import * as Constants from "config";
import Document from "documents/document";
import Session from "users/__session/session";
import { addDocument, removeDocument } from "./documents-redux-slice";
import DocumentSchema from "documents/_schema/document-schema";

export const documentsHubConnection = new HubConnectionBuilder()
  .configureLogging(LogLevel.Debug)
  .withUrl(`${Constants.apiBaseUrl}/documentHub`, {
    skipNegotiation: true,
    transport: HttpTransportType.WebSockets,
    accessTokenFactory: () => Session.loadFromStorage(() => {}).authToken?.value ?? "",
  })
  .withAutomaticReconnect(getSignalRReconnectDelaysMs())
  .build();

const toDocument = (payload: unknown): Document | undefined => {
  if (DocumentSchema.isValidJSON(payload)) {
    return Document.fromJSON(payload);
  }
  return undefined;
};

const callbacks = withCallbacks()
  .add("document-created", (payload: unknown) => (dispatch) => {
    const document = toDocument(payload);
    if (document) dispatch(addDocument(document));
  })
  .add("document-updated", (payload: unknown) => (dispatch) => {
    const document = toDocument(payload);
    if (document) dispatch(addDocument(document));
  })
  .add("document-deleted", (payload: unknown) => (dispatch) => {
    const document = toDocument(payload);
    if (document) dispatch(removeDocument(document));
  });

export const documentsSignalRReduxMiddleware = reduxSignalRMiddleware({
  callbacks,
  connection: documentsHubConnection,
  connectionHealth: { key: "documents", label: "Documents" },
  shouldConnectionStartImmediately: true,
});
